import { render, staticRenderFns } from "./AssignNew.vue?vue&type=template&id=11284992&scoped=true&"
import script from "./AssignNew.vue?vue&type=script&lang=js&"
export * from "./AssignNew.vue?vue&type=script&lang=js&"
import style0 from "./AssignNew.vue?vue&type=style&index=0&id=11284992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11284992",
  null
  
)

export default component.exports